import { Injectable } from '@angular/core';
import { RaintreeResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { AreYouUpdatedResponse } from '../interfaces/are-you-updated.interface';

@Injectable({
  providedIn: 'root',
})
export class ContactReachService extends ApiService {
  public getPhnNumber(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.SHOW_PHN_NUMBER, {
      params: reqData,
    });
  }
  public getPhnNumberAreYouUpdated(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.SHOW_PHN_NUMBER_ARE_YOU_UPDATED, {
      params: reqData,
    });
  }
  public getPhnNumberPM(reqData: any): Observable<any> {
    return this.get<any>(ROUTES.SHOW_PHN_NUMBER_PM, {
      params: reqData,
    });
  }
}
